var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decoration-container"},[_c('div',{staticClass:"ground-glass-effect",style:(`background: ${ _vm.backgroundColor };backdrop-filter: blur(${_vm.blur || 6 }px);`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }